import { collection, doc, setDoc, updateDoc, deleteDoc, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebaseConfig';

let _userId = null;
let _items  = [];
let _unsub  = null;

export function initInboxService(userId) {
  if (_unsub) { _unsub(); _unsub = null; }
  _userId = userId;
  _items  = [];

  if (!userId) {
    window.dispatchEvent(new CustomEvent('projectly_inbox_update'));
    return;
  }

  const q = query(
    collection(db, 'users', userId, 'inbox'),
    orderBy('timestamp', 'desc')
  );
  _unsub = onSnapshot(
    q,
    snap => {
      _items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      window.dispatchEvent(new CustomEvent('projectly_inbox_update'));
    },
    err => console.error('[inbox snapshot]', err)
  );
}

export function getInboxItems() { return _items; }

export function getUnreadCount() {
  return _items.filter(i => !i.read && i.folder !== 'archive').length;
}

export async function addInboxItem(item) {
  if (!_userId) return;
  try {
    await setDoc(doc(db, 'users', _userId, 'inbox', item.id), item);
  } catch (e) { console.error('[addInboxItem]', e); }
}

export async function updateInboxItem(id, updates) {
  if (!_userId) return;
  try {
    await updateDoc(doc(db, 'users', _userId, 'inbox', id), updates);
  } catch (e) { console.error('[updateInboxItem]', e); }
}

export async function deleteInboxItem(id) {
  if (!_userId) return;
  try {
    await deleteDoc(doc(db, 'users', _userId, 'inbox', id));
  } catch (e) { console.error('[deleteInboxItem]', e); }
}
